import {
  ArrowDown01Icon,
  ArrowDown02Icon,
  ArrowRight02Icon,
  ArrowUp02Icon,
  Calendar04Icon,
  Cancel01Icon,
  Download01Icon,
  DragDropVerticalIcon,
  FileEmpty02Icon,
  HashtagIcon,
  Layers01Icon,
  Menu01Icon,
  Menu02Icon,
  Moon02Icon,
  ServerStack01Icon,
  SmartPhone01Icon,
  Sun01Icon,
  ViewIcon,
  ViewOffSlashIcon,
  Search01Icon,
  ArrowRight01Icon,
  File01Icon,
  Timer02Icon,
  Tick01Icon,
  MinusSignCircleIcon,
  CircleIcon,
  Loading01Icon,
  Delete04Icon,
  ArrowLeft02Icon,
  Mail01Icon,
  ComputerIcon,
  Alert02Icon,
  WindowsOldIcon,
  AppleIcon,
  ArrowLeft03Icon,
  ArrowRight03Icon,
  CheckmarkCircle01Icon,
  CheckmarkCircle02Icon,
  CheckmarkSquare01Icon,
  SquareIcon,
  RadioButtonIcon,
  CheckmarkBadge02Icon,
  Logout02Icon,
  AlarmClockIcon,
  Alert01Icon,
  AlertDiamondIcon,
  ArrowDownFromLineIcon,
  CalendarCheckOut01Icon,
  FullSignalIcon,
  UserCircle02Icon,
  CalendarRemove01Icon,
  AlertSquareIcon,
  ToggleOnIcon,
} from "@hugeicons-pro/core-solid-rounded";

import {
  AddCircleIcon,
  Chat01Icon,
  FolderLibraryIcon,
  Invoice03Icon,
  LaptopIcon,
  Ticket01Icon,
  CircleStrokeRounded,
  SmileIcon,
  SentIcon,
  NoteEditIcon,
  AttachmentIcon,
  ScanImageIcon,
  Pdf01Icon,
  Image01Icon,
  Image02Icon,
  Xls01Icon,
  Doc01Icon,
  Csv01Icon,
  Txt01Icon,
  Attachment01Icon,
  WhiteboardIcon,
  ContractsIcon,
  MinusSignCircleIcon as MinusSignCircleIconStroke,
  ArrowLeft01Icon as ArrowLeft01IconStroke,
  ArrowRight01Icon as ArrowRight01IconStroke,
  ArrowDown01Icon as ArrowDown01IconStroke,
  LayoutTwoColumnIcon as LayoutTwoColumnIconStroke,
  ArrowLeftDoubleIcon as ArrowLeftDoubleIconStroke,
  ArrowRightDoubleIcon as ArrowRightDoubleIconStroke,
  Blockchain01Icon as Blockchain01IconStroke,
  Progress03Icon as Progress03IconStroke,
  DashedLine01Icon as NoPrioritySignalIconStroke,
  TaskEdit01Icon as TaskEdit01IconStroke,
  Blockchain04Icon as Blockchain04IconStroke,
  Clock05Icon,
  // Submitted-form answers in the ticket timeline (ticket-form-submitted-card.vue), one per field type.
  EqualSignIcon,
  TextAlignLeftIcon,
  CheckmarkCircle02Icon as CheckmarkCircle02IconStroke,
  CheckmarkSquare02Icon as CheckmarkSquare02IconStroke,
  HashtagIcon as HashtagIconStroke,
  Mail02Icon,
  Call02Icon,
  Link04Icon,
  Calendar03Icon,
  Clock01Icon,
  TextIcon,
  CheckmarkSquare01Icon as CheckmarkSquare01IconStroke,
  RadioButtonIcon as RadioButtonIconStroke,
  // Remote Access tabs (same weight as the web app's policy-page toggle icons)
  LaptopIcon as LaptopIconStroke,
  UserGroupIcon as UserGroupIconStroke,
} from "@hugeicons-pro/core-stroke-rounded";

import { 
  ArrowRight01Icon as ArrowRight01IconStandard,
  ArrowDown01Icon as ArrowDown01IconStandard
} from "@hugeicons-pro/core-stroke-standard";

import { 
  LowSignalIcon,MediumSignalIcon  } 
  from '@hugeicons-pro/core-bulk-rounded';

/**
 * Remote Access menu glyph: Figma's "GC-custom-icon" (two offset chevrons), not in Hugeicons.
 * Drawn on a 16px grid in Figma, scaled ×1.5 to Hugeicons' 24 viewBox; use stroke-width 1.8 for Figma's 1.2px at 16px.
 */
const RemoteAccessIconStroke: [string, Record<string, string>][] = [
  ["path", { d: "M4.2 20.25C4.2 20.25 10.2 15.8311 10.2 14.25C10.2 12.6688 4.2 8.25 4.2 8.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8", key: "0" }],
  ["path", { d: "M19.8 15.75C19.8 15.75 13.8 11.3311 13.8 9.75C13.8 8.16884 19.8 3.75 19.8 3.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.8", key: "1" }],
];

export const hugeIcons = {
  remoteAccess: RemoteAccessIconStroke,
  laptopStroke: LaptopIconStroke,
  userGroupStroke: UserGroupIconStroke,
  whiteboard: WhiteboardIcon,
  blockchain04: Blockchain04IconStroke,
  taskEdit01: TaskEdit01IconStroke,
  alertSquare: AlertSquareIcon,
  noPrioritySignal: NoPrioritySignalIconStroke,
  lowSignal: LowSignalIcon,
  normalSignal: MediumSignalIcon,
  highSignal: FullSignalIcon,
  calendarRemove01: CalendarRemove01Icon,
  progress03: Progress03IconStroke,
  calendarCheckOut01: CalendarCheckOut01Icon,
  userCircle02: UserCircle02Icon,
  arrowDownFromLine: ArrowDownFromLineIcon,
  AlertDiamond: AlertDiamondIcon,
  blockchain01: Blockchain01IconStroke,
  addCircle: AddCircleIcon,
  attachment: AttachmentIcon,
  arrowDown01: ArrowDown01IconStroke,
  arrowDown02: ArrowDown02Icon,
  arrowRight02: ArrowRight02Icon,
  arrowUp02: ArrowUp02Icon,
  calendar04: Calendar04Icon,
  cancel01: Cancel01Icon,
  menu01: Menu01Icon,
  menu02: Menu02Icon,
  chat01: Chat01Icon,
  contracts: ContractsIcon,
  download01: Download01Icon,
  dragDropVertical: DragDropVerticalIcon,
  fileEmpty02: FileEmpty02Icon,
  folderLibrary: FolderLibraryIcon,
  hashtag: HashtagIcon,
  invoice03: Invoice03Icon,
  laptop: LaptopIcon,
  desktop: ComputerIcon,
  layers01: Layers01Icon,
  layout2Column: LayoutTwoColumnIconStroke,
  computerDesktop: ComputerIcon,
  scanImage: ScanImageIcon,
  serverStack01: ServerStack01Icon,
  sent: SentIcon,
  smile: SmileIcon,
  smartPhone01: SmartPhone01Icon,
  ticket01: Ticket01Icon,
  view: ViewIcon,
  viewOffSlash: ViewOffSlashIcon,
  moon02: Moon02Icon,
  sun01: Sun01Icon,
  search01: Search01Icon,
  arrowRight01: ArrowRight01Icon,
  file01: File01Icon,
  timer02: Timer02Icon,
  checkboxChecked: CheckmarkSquare01Icon,
  checkbox: SquareIcon,
  tick01: Tick01Icon,
  minus01: MinusSignCircleIcon,
  circle: CircleIcon,
  loading01: Loading01Icon,
  delete04: Delete04Icon,
  arrowLeft02: ArrowLeft02Icon,
  pdf01: Pdf01Icon,
  image01: Image01Icon,
  image02: Image02Icon,
  attachment01: Attachment01Icon,
  mail01: Mail01Icon,
  arrow_upward: ArrowUp02Icon,
  error: Alert02Icon,
  circleStroke: CircleStrokeRounded,
  RadioButton: RadioButtonIcon,
  minusSignCircle: MinusSignCircleIcon,
  checkmarkCircle01: CheckmarkCircle01Icon,
  checkmarkCircle02: CheckmarkCircle02Icon,
  windows: WindowsOldIcon,
  apple: AppleIcon,
  chevron_left: ArrowLeft01IconStroke,
  chevron_right: ArrowRight01IconStroke,
  last_page: ArrowRight03Icon,
  first_page: ArrowLeft03Icon,
  arrow_drop_down: ArrowDown01IconStroke,
  warning: Alert02Icon,
  excel01: Xls01Icon,
  word01: Doc01Icon,
  cancel: Cancel01Icon,
  checkmarkicon: CheckmarkBadge02Icon,
  logoutIcon02: Logout02Icon,
  noteEdit: NoteEditIcon,
  chevron_double_left: ArrowLeftDoubleIconStroke,
  chevron_double_right: ArrowRightDoubleIconStroke,
  ArrowRightIconStandard: ArrowRight01IconStandard,
  ArrowDownIconStandard: ArrowDown01IconStandard,
  csv01: Csv01Icon,
  txt01: Txt01Icon,
  alarmClock: AlarmClockIcon,
  clock05: Clock05Icon,
  alert01: Alert01Icon,
  check_circle: CheckmarkCircle01Icon,
  equalSign: EqualSignIcon,
  textAlignLeft: TextAlignLeftIcon,
  checkmarkCircle02Stroke: CheckmarkCircle02IconStroke,
  checkmarkSquare02Stroke: CheckmarkSquare02IconStroke,
  hashtagStroke: HashtagIconStroke,
  mail02: Mail02Icon,
  call02: Call02Icon,
  link04: Link04Icon,
  calendar03: Calendar03Icon,
  clock01: Clock01Icon,
  toggleOn: ToggleOnIcon,
  text: TextIcon,
  CheckmarkSquare01IconStroke: CheckmarkSquare01IconStroke,
  radioButtonStroke: RadioButtonIconStroke,
};

export type HugeIconName = keyof typeof hugeIcons;
